import {combineReducers} from 'redux';

import {
  auth,
  INITIAL_STATE as INITIAL_STATE_AUTH
} from './auth/reducer';
import {
  checkpoints,
  INITIAL_STATE as INITIAL_STATE_CHECKPOINTS
} from './checkpoints/reducer';
import {
  checkpointTypes,
  INITIAL_STATE as INITIAL_STATE_CHECKPOINT_TYPES
} from './checkpointTypes/reducer';
import {
  checks,
  INITIAL_STATE as INITIAL_STATE_CHECKS
} from './checks/reducer';
import {
  INITIAL_STATE as INITIAL_STATE_LIBRARIES,
  libraries
} from './libraries/reducer';
import {
  INITIAL_STATE as INITIAL_STATE_NOTIFICATIONS,
  notifications
} from './notifications/reducer';
import {
  INITIAL_STATE as INITIAL_STATE_PREFERENCES,
  preferences
} from './preferences/reducers';
import {
  INITIAL_STATE as INITIAL_STATE_USER_DEFINED_ROLES,
  userDefinedRoles
} from './userDefinedRoles/reducer';

export const INITIAL_STATE = {
  auth: INITIAL_STATE_AUTH,
  checkpointTypes: INITIAL_STATE_CHECKPOINT_TYPES,
  checkpoints: INITIAL_STATE_CHECKPOINTS,
  checks: INITIAL_STATE_CHECKS,
  libraries: INITIAL_STATE_LIBRARIES,
  notifications: INITIAL_STATE_NOTIFICATIONS,
  preferences: INITIAL_STATE_PREFERENCES,
  userDefinedRoles: INITIAL_STATE_USER_DEFINED_ROLES
};

export const reducer = combineReducers({
  auth,
  checkpointTypes,
  checkpoints,
  checks,
  libraries,
  notifications,
  preferences,
  userDefinedRoles
});
